<template>
  <div id="app" class="d-flex" :class="hasBg ? 'background-gray' : ''">
    <layout-sidebar v-if="isNotAuthRoute" />
    <div
      class="w-full overflow-hidden"
      :class="isNotAuthRoute ? 'layout-responsive' : 'layout-responsive-auth'"
    >
      <router-view />
    </div>
  </div>
</template>
<script>
import LayoutSidebar from "./components/layout/LayoutSidebar";
export default {
  components: {
    LayoutSidebar
  },
  computed: {
    hasBg() {
      return (
        this.$route.path === "/posts" ||
        this.$route.path === "/tags" ||
        this.$route.path === "/categories" ||
        this.$route.path === "/reviews" ||
        this.$route.path === "/git" ||
        this.$route.name === "Post comments" ||
        this.$route.name === "Page reviews"
      );
    },
    isNotAuthRoute() {
      return (
        this.$route.path.startsWith("/posts") ||
        this.$route.path.startsWith("/tags") ||
        this.$route.path.startsWith("/categories") ||
        this.$route.path.startsWith("/post/") ||
        this.$route.path.startsWith("/git") ||
        this.$route.path.startsWith("/reviews")
      );
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700'");
@import url("./assets/css/bootstrap-grid.css");
@import url("./assets/css/main.css");
.background-gray {
  background: #f1f4f7 !important;
  min-height: 100vh;
}
@media screen and (max-width: 630px) {
  .layout-responsive {
    margin-top: 120px;
    width: 100% !important;
  }
  .layout-responsive-auth {
    margin-top: 40px;
    width: 100% !important;
  }
}
</style>
